import svc from "svc";
import { types as lineTypes } from "store/salesorderLines";
import { types as orderTypes } from "store/salesOrders";
import { types as layoutTypes } from "store/layout";
import { actions as bpActions } from "store/businessPartners";
import { actions as orderActions } from "store/salesOrders";
import {find} from 'lodash';

export const types = {
	SET_STATE: 'COPYDOC/SET_STATE',
	SET_SEARCH_STATE: 'COPYDOC/SET_SEARCH_STATE',
};

export const initialState = {
	open: false,
	searchValues: {
		DocNum: '',
		CardCode: '',
		CardName: '',
		FromDate: '',
		ToDate: '',
		DocStatus: '',
		Canceled: '',
		SlpCode: '',
	},
	searching: false,
	copying: false,
	rows: [],

};

export default ( state = initialState, action ) => {
	switch (action.type) {
		case types.SET_STATE:
			return { ...state, ...action.data };
		case types.SET_SEARCH_STATE:
			return { ...state, searchValues: { ...state.searchValues, ...action.data } };
		default:
			return state;
	}
}

export const actions = {
	setState: ( data ) => ({ type: types.SET_STATE, data }),
	setSearch: ( data ) => ({ type: types.SET_SEARCH_STATE, data }),
	close: () => ({ type: types.SET_STATE, data: { ...initialState } }),
	open: () => ({ type: types.SET_STATE, data: { ...initialState, open: true } }),
	copy: (docEntry, cardCode, type, draft, targetType) => {
		return (dispatch, getState) => {
			let state = getState().salesOrders;
			let bp = getState().businessPartners;
			dispatch({ type: types.SET_STATE, data: { copying: true, searching: true } });

			//let isDraft = state.isDraft;
			let extras = {
				Status: 'O',
				CANCELED: 'N',
				PostingDate: getDate(),
				DueDate: getDate(),
				DocumentDate: getDate(),
				Printed: 'N',
				U_TSPayflowID: '',
				//ShipTo: state.order.ShipTo,
				//BillTo: state.order.BillTo,
				BaseCard: '',
				BaseRef: '',
				BaseType: '',
				TargetType: '',
				TargetEntry: '',
				DocEntry: null,
				CardCode: cardCode,
			};

			svc.send('document', {
				method: 'copy',
				save: false,
				sourceType: type,
				sourceKey: docEntry,
				cardCode: cardCode,
				targetType: targetType,
				isDraft: draft,
				extras: extras,
			}).then(res => {
				let stateData = {
					order: {
						...state.order,
						...res.payload.header,
					},
					mode: 'new',
					hasChanged: true,
					loadingOrder: false,
					pageError: false,
					isQuote: targetType === 'quote',
					isDraft: false,
					submitAction: 'save',
					//freight: { ...state.freight, ...res.payload.freight },
					//quoteUDFs: { ...state.quoteUDFs },
					deletedLines: [],
					showPrintDialog: false,
					showPrintDialogOnLoad: false,
					showSlowPokeDialog: false,
					DocEntry: null,
				};

				//let warehouses = [ ...state.warehouses ];
				let lines = (res.payload.lines || []).map(line => {
					let {BaseDocType, BaseDocLine, BaseDocEntry, ...lineData} = line;
					return lineData;
				});

				/*
				for ( let i = 0; i < lines.length; i++ ) {
					if ( warehouses.indexOf(lines[ i ].WhsCode) === -1 ) {
						warehouses.push(lines[ i ].WhsCode);
					}
				}
				 */

				//stateData.warehouses = warehouses;

				dispatch(bpActions.setState({resized: true}));
				dispatch({ type: types.SET_STATE, data: { ...initialState } });
				dispatch({
					type: orderTypes.SET_STATE,
					data: stateData,
				});
				dispatch({ type: lineTypes.RESET_ALL });
				dispatch({
					type: lineTypes.UPDATE_LINE,
					data: lines,
					lineID: 0,
				});

				// Set addresses
				let currentOrder = getState().salesOrders.order;
				let bpShippingAddresses = bp.addresses.shipping;
				let bpBillingAddresses = bp.addresses.billing;
				let billToID = currentOrder.BillTo;
				let shipToID = currentOrder.ShipTo;
				let billTo = find(bpBillingAddresses, {ID: billToID});
				let shipTo = find(bpShippingAddresses, {ID: shipToID});

				if(billTo) {
					dispatch(orderActions.setAddress('billing', billTo));
				}

				if(shipTo) {
					dispatch(orderActions.setAddress('shipping', shipTo));
				}

				dispatch(orderActions.updateTotals());
				dispatch({
					type: layoutTypes.NOTIFY,
					text: `Copied document.`,
				});


			}).catch(err => {
				console.error(err);
				dispatch({ type: types.SET_STATE, data: { copying: false, searching: false } });
				dispatch({
					type: layoutTypes.NOTIFY,
					text: err.msg,
				});
			});
		}
	},
};



function getDate(addDays = 0) {
	let now = new Date();
	let adjusted = new Date(now);
	adjusted.setDate(adjusted.getDate() + addDays);

	let dd = adjusted.getDate();
	let mm = adjusted.getMonth() + 1; //January is 0!
	let yyyy = adjusted.getFullYear();

	if ( dd < 10 ) {
		dd = '0' + dd;
	}
	if ( mm < 10 ) {
		mm = '0' + mm;
	}

	return `${yyyy}-${mm}-${dd}`;
}